import { useNavigate } from "react-router-dom";
import { Shield, BookOpen, MessageSquare, Bot, Scale, Briefcase, Search } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Features() {
  const navigate = useNavigate();

  const features = [
    {
      icon: <Bot className="h-8 w-8 text-orange-600" />,
      title: "AI-Assistent",
      description: "Få juridisk veiledning og svar på spørsmål fra vår avanserte AI-assistent som er spesialisert på norsk rett.",
      link: "/assistant"
    },
    {
      icon: <Briefcase className="h-8 w-8 text-orange-600" />,
      title: "Saksbehandling",
      description: "Effektiv håndtering av juridiske saker med automatisert dokumentgenerering og fremdriftsstyring.",
      link: "/cases"
    },
    {
      icon: <Search className="h-8 w-8 text-orange-600" />,
      title: "Semantisk Lovsøk",
      description: "Søk i lover og forskrifter med avansert AI-teknologi som forstår konteksten i dine spørsmål.",
      link: "/search"
    },
    {
      icon: <BookOpen className="h-8 w-8 text-orange-600" />,
      title: "Dokumentgenerator",
      description: "Lag profesjonelle juridiske dokumenter automatisk basert på dine behov og preferanser.",
      link: "/documents"
    },
    {
      icon: <Scale className="h-8 w-8 text-orange-600" />,
      title: "Rettslig Analyse",
      description: "Få dyp innsikt i juridiske problemstillinger med vår avanserte analyseteknologi.",
      link: "/assistant"
    },
    {
      icon: <Shield className="h-8 w-8 text-orange-600" />,
      title: "Sikkerhet og Personvern",
      description: "Dine data er trygge med vår GDPR-kompatible plattform og ende-til-ende kryptering.",
      link: "/settings"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 to-white">
      <div className="container mx-auto px-4 py-16">
        {/* Header Section */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Våre Funksjoner
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Utforsk hvordan vår innovative juridiske teknologi kan effektivisere din arbeidshverdag
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow duration-300"
            >
              <div className="flex items-center justify-center w-12 h-12 rounded-full bg-orange-100 mb-4">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 mb-4">
                {feature.description}
              </p>
              <Button
                variant="ghost"
                className="text-orange-600 hover:text-orange-700 hover:bg-orange-50 p-0"
                onClick={() => navigate(feature.link)}
              >
                Lær mer
              </Button>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="text-center mt-16">
          <h2 className="text-2xl font-semibold text-gray-900 mb-4">
            Klar til å komme i gang?
          </h2>
          <p className="text-gray-600 mb-8">
            Opprett en konto nå og opplev hvordan vi kan hjelpe deg med dine juridiske behov
          </p>
          <Button
            className="bg-orange-600 text-white hover:bg-orange-700"
            onClick={() => navigate("/signup")}
          >
            Kom i gang nå
          </Button>
        </div>
      </div>
    </div>
  );
}